import { Dispatch, SetStateAction } from "react";
import { MainTableHeaderTitle } from "../../shared/Style/Style";
import { ShareLinksTableRow } from "../styles";
import { StatusFilter } from "./StatusFilter";
import { Filters } from "../ShareLinks";

interface ShareLinksTableHeaderProps {
  filters: Filters;
  setFilters: Dispatch<SetStateAction<Filters>>;
  setPage: Dispatch<SetStateAction<number>>;
}

const headerColumns: { label: string; hasFilter?: boolean }[] = [
  { label: "Код" },
  { label: "Посилання" },
  { label: "Контент" },
  { label: "Статус", hasFilter: true },
  { label: "Дійсне до" },
  { label: "" },
];

export const ShareLinksTableHeader = ({
  filters,
  setFilters,
  setPage,
}: ShareLinksTableHeaderProps) => {
  return (
    <ShareLinksTableRow>
      {headerColumns.map(({ label, hasFilter }) => (
        <MainTableHeaderTitle
          key={label || "actions"}
          style={{ whiteSpace: "nowrap", width: "100%" }}
        >
          {hasFilter && label === "Статус" ? (
            <StatusFilter
              label={label}
              selectedValue={filters.isActive}
              onChange={(value) => {
                setFilters((prev) => ({ ...prev, isActive: value }));
                setPage(0);
              }}
            />
          ) : (
            label
          )}
        </MainTableHeaderTitle>
      ))}
    </ShareLinksTableRow>
  );
};
